export default "__VITE_ASSET__2582aae2__"